export class EnumHelper {
    public static getValueList(_textValues: { [index: number]: EnumValue }, sort: boolean): Array<EnumIdLabel> {
        var retval = new Array<EnumIdLabel>();

        for (var key in _textValues) {
            var id = Number(key);
            retval.push(new EnumIdLabel(id, _textValues[id].textValue, _textValues[id].order));
        }

        if (sort) {
            return retval.sort((a, b) => {
                return a.label > b.label ? 1 : a.label < b.label ? -1 : 0;
            });
        }

        return retval.sort((a, b) => {
            return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
        });
    }
}

export class EnumIdLabel {
    constructor(public id: number, public label: string, public order: number) {
    }
}

export class EnumValue {
    constructor(public textValue: string, public order: number) { }
}



// WEBPACK FOOTER //
// ./enums/enum.helper.ts